module.exports = __webpack_public_path__ + "static/media/ic_buffet.5fe4a173.svg";